/**
 * Merkflow Sidebar — section header.
 *
 * Extracted from Sidebar.tsx. Renders a section label with a divider and
 * an optional collapse/expand toggle (used only on the first section so
 * there's a single control for folding the whole dock).
 */

import { useTranslation } from 'react-i18next';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

export function SidebarSectionHeader({
  label,
  collapsed,
  onToggleCollapse,
  accent = false,
}: {
  label: string;
  collapsed: boolean;
  onToggleCollapse?: () => void;
  accent?: boolean;
}) {
  const { t } = useTranslation();
  if (collapsed) {
    return onToggleCollapse ? (
      <div className="mt-4 mb-1 flex items-center justify-center px-2">
        <button
          type="button"
          onClick={onToggleCollapse}
          className="bg-subtle text-text-tertiary hover:text-accent rounded-lg p-1.5 transition-colors"
          title={t('common.expandSidebar')}
          aria-label={t('common.expandSidebar')}
        >
          <ChevronsRight className="h-4 w-4" />
        </button>
      </div>
    ) : (
      <div className="mt-4 mb-1 h-2" />
    );
  }
  return (
    <div className="mt-4 mb-1 flex items-center gap-2 px-5">
      <p className={`mk-section-label ${accent ? '!text-accent' : ''}`}>{label}</p>
      <div className="bg-border h-px flex-1" />
      {onToggleCollapse && (
        <button
          type="button"
          onClick={onToggleCollapse}
          className="text-text-tertiary hover:text-accent transition-colors"
          title={t('common.collapseSidebar')}
          aria-label={t('common.collapseSidebar')}
        >
          <ChevronsLeft className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
